import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FileUploader } from 'ng2-file-upload';
import { MessageService } from "app/utils/toastr-custom/message.service";

@Component({
  selector: 'app-file-uploader-dropzone',
  templateUrl: './file-uploader-dropzone.component.html',
  styleUrls: ['./file-uploader-dropzone.component.scss'],
})
export class FileUploaderDropzoneComponent {
    LIMITE_ARQUIVO_PADRAO = 5;

    @Input() disabled: boolean;
    @Input() multiplosArquivos: boolean = false;
    @Input() limiteArquivos: number = this.LIMITE_ARQUIVO_PADRAO; //se existe determina limite máximo de uploads de arquivos
    @Input() isArquivoValido: (arquivo: File) => boolean;

    @Output() onUpload = new EventEmitter<File>(); //se implementado, emite quando adiciona um arquivo
    @Output() onUploadAll = new EventEmitter<File[]>(); //se implementado, emite quando todos os arquivos foram adicionados

    enviado = 0;
    isUploading = false;
    
    private arquivos: File[] = [];
    public hasAnotherDropZoneOver: boolean = false;
    public hasBaseDropZoneOver: boolean = false;
    public uploader: FileUploader = new FileUploader({
      url: 'URL',
      isHTML5: true
    });

    constructor(
      private _messageService: MessageService
    ) {
    }


    fileOverBase(event: any): void {
      this.hasBaseDropZoneOver = event;
    }

    fileDrop(event: any) {
      if (!this.multiplosArquivos) {
        this.uploader.queue = [this.uploader.queue[0]];
      }

      if (this.uploader.queue.length > this.limiteArquivos) {
        this._messageService.warning('Atenção', `Você só pode subir ${this.limiteArquivos} arquivos por vez.`);
        this.uploader.queue = [];
      } else {
        this.upload();
      }
    }

    upload() {
      this.enviado = 0;
      this.isUploading = true;

      for (let index = 0; index < this.uploader.queue.length; index++) {
        const arquivo = new File([this.uploader.queue[index]._file], this.uploader.queue[index]._file.name, { type: this.uploader.queue[index]._file.type })

        if (this.isArquivoValido === undefined || this.isArquivoValido(arquivo)) {
          this.arquivos.push(arquivo);
          this.onUpload.emit(arquivo);
        }

      }

      if (this.arquivos.length > 0) {
        this.onUploadAll.emit(this.arquivos);
      }

      if (this.arquivos.length === 0) {
        this.isUploading = false;
      }

      this.clearUploader();
    }

    inicioUpload() {
      this.isUploading = true;
    }

    arquivoSalvo() {
      this.enviado++;

      if (this.enviado === this.arquivos.length) {
        this.isUploading = false;
        this.arquivos = [];
      }
    }

    clearUploader() {
      this.uploader.queue = [];
    }
}